<template>
  <section
    v-if="caseData.data"
    class="pb-1"
  >
    <h5
      v-if="caseData.data"
      class="text-nowrap font-weight-bolder"
    >
      {{ getUniqueId(caseData) }}
      <b-badge
        v-if="caseData.status.toLowerCase() === 'pending'"
        variant="light-primary"
        class="mx-1"
      >
        <span>{{ caseData.status }}</span>
      </b-badge>
      <b-badge
        v-else
        variant="light-danger"
        class="mx-1"
      >
        <span>{{ caseData.status }}</span>
      </b-badge>
    </h5>
    <div
      v-if="
        Object.keys($store.state.firTrackerStore.currentFIR).includes(
          'court_name'
        )
      "
    >
      <p class="text-secondary font-italic">
        {{ $store.state.firTrackerStore.currentFIR.court_name }}
      </p>
    </div>
    <h4 class="text-primary">
      {{ caseData.title }}
    </h4>
  </section>
</template>

<script>
import {
  BBadge,
  BRow,
  BButton,
  BCol,
  BFormGroup,
  BFormTextarea,
} from 'bootstrap-vue'

export default {
  components: {
    BBadge, BRow, BButton, BCol, BFormGroup, BFormTextarea,
  },
  props: {
    data: {
      default: null,
    },
  },
  data() {
    return {
      caseData: this.data,
    }
  },
}
</script>
